<template>
	<VInputMask
		ref="company-inn-input"
		:value="company.additionalAttributes.inn.value"
		:label="company.additionalAttributes.inn.name"
		@input="value => company.additionalAttributes.inn.value = value"
		layout="vertical"
		:precision="0"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="### ### ###"
		:validate-method="UzUtils.validateINN"
		:disabled="readOnly"
	/>
</template>

<script>

import UzUtils from '@/core/utils/regional/UzUtils'
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'UZAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			UzUtils,
		}
	},
};
</script>
